export class JanglService {
    
    constructor($http, $window) {
        this.$http = $http;
        this.baseUrl = 'https://api.jangl.com/';
        // look for configuration on window object on init. This allows easy configuration
        // for consumers who do not want to know about angular. This is primarily intended for
        // testing and demo's with non-production backends. It must be set in a <script> tag 
        // prior to bootstrapping angular.
        if ($window['jangl'] && $window['jangl'].baseUrl) {
            this.baseUrl = $window['jangl'].baseUrl;
        }
    }

    // @see: https://demo.rpmsites.com/affiliates/integrations/b5bd03720ea8348e30f3fc1845414c822ebcf414/
    captureHealthInsuranceLead(token, data) {
        return this._post('v2/health_insurance/capture', token, data);
    }

    captureLifeInsuranceLead(token,data) {
        return this._post('v2/life_insurance/capture', token, data);
    }

    _post(url, token, data) {
        let request = {
            method: 'POST',
            url: this.baseUrl + url,
            headers: {
                'Authorization': 'Token ' + token,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: data
        }

        return this.$http(request);
    }

    get(url) {
        let request = {
            method: 'GET',
            url: url,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return this.$http(request);
    }
}

//  default injections.
JanglService.$inject = ['$http', '$window'];



// WEBPACK FOOTER //
// ./app/jangl/JanglService.js